import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { is, List } from 'immutable';
import ReduxRecord from './reduxRecord';
import { QUIZ_SESSION_RESULT_FETCH_CALL } from '@instructure/quiz-common';
import { getSessionItemResultsByIds } from '../selectors/sessionItemResults';
export var QuizSessionResult = /*#__PURE__*/function (_ReduxRecord) {
  function QuizSessionResult() {
    _classCallCheck(this, QuizSessionResult);
    return _callSuper(this, QuizSessionResult, arguments);
  }
  _inherits(QuizSessionResult, _ReduxRecord);
  return _createClass(QuizSessionResult, [{
    key: "isGraded",
    value: function isGraded() {
      return this.status === 'graded' || this.autogradingFailed();
    }
  }, {
    key: "autogradingFailed",
    value: function autogradingFailed() {
      return this.status === 'autograding_failed';
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "getSessionItemResults",
    value: function getSessionItemResults() {
      return getSessionItemResultsByIds(this.getState(), this.sessionItemResults);
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      var mods = this.getState().getIn(['modifications', 'quizSessionResults', this.id]);
      return QuizSessionResult.create(this.merge(mods));
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return !is(this.getWorkingInstance(), this);
    }
  }], [{
    key: "fetcherTag",
    value: function fetcherTag(id) {
      return "".concat(QUIZ_SESSION_RESULT_FETCH_CALL, "_").concat(id);
    }
  }]);
}(ReduxRecord({
  createdAt: null,
  fudgePoints: null,
  gradingMethod: null,
  id: '0',
  percentage: null,
  pointsPossible: null,
  quizSession: null,
  score: null,
  sessionItemResults: List(),
  status: null,
  updatedAt: null
}));
export default QuizSessionResult;